import { render, staticRenderFns } from "./TempConfig.vue?vue&type=template&id=3670f76f&scoped=true"
import script from "./TempConfig.vue?vue&type=script&lang=js"
export * from "./TempConfig.vue?vue&type=script&lang=js"
import style0 from "./TempConfig.vue?vue&type=style&index=0&id=3670f76f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3670f76f",
  null
  
)

export default component.exports